/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longest word`)
};

const es_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabra más larga`)
};

const de_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längster Wort`)
};

const nl_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langste woord`)
};

const fr_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot le plus long`)
};

const it_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parola più lunga`)
};

const pt_br2_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavra mais longa`)
};

const pt_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palavra mais longa`)
};

const ja_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最長単語`)
};

const zh_wc_longest_word = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最长单词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wc_longest_word = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wc_longest_word(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wc_longest_word", locale)
	if (locale === "en") return en_wc_longest_word(inputs)
	if (locale === "es") return es_wc_longest_word(inputs)
	if (locale === "de") return de_wc_longest_word(inputs)
	if (locale === "nl") return nl_wc_longest_word(inputs)
	if (locale === "fr") return fr_wc_longest_word(inputs)
	if (locale === "it") return it_wc_longest_word(inputs)
	if (locale === "pt-BR") return pt_br2_wc_longest_word(inputs)
	if (locale === "pt") return pt_wc_longest_word(inputs)
	if (locale === "ja") return ja_wc_longest_word(inputs)
	return zh_wc_longest_word(inputs)
};